<script>

/**
 * Loading component
 */
export default {
  components: {
    
  },
  data() {
    return {};
  },
  mounted() {

  },
  computed: {
    getHeight: function() {
      return this.height != 0 ? this.height : window.screen.height - 180;
    }
  },
  props: {
    loaded: {
      type: Boolean,
      default: false,
    },
    height: {
      type: Number,
      default: 0,
    }
  },
};
</script>
<template>
  <div v-show="loaded == false" :style="`display: flex; flex-direction: column; justify-content: center; align-items: center; height: ${getHeight}px;`">
    <div class="preloader-component">
      <div class="status">
        <div class="spinner-chase">
          <div class="chase-dot"></div>
          <div class="chase-dot"></div>
          <div class="chase-dot"></div>
          <div class="chase-dot"></div>
          <div class="chase-dot"></div>
          <div class="chase-dot"></div>
        </div>
      </div>
    </div>
  </div>
</template>